import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';

/**
 * Repository for stored files (e.g. driver avatars, taxi images).
 * The file route requires the auth header, so files are fetched as blobs
 * and turned into object urls by the caller.
 */
export default class FileRepository extends EntityBaseRepository {
    public getFile(id: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`file/${id}`, { responseType: 'blob' });
    }

    /**
     * Fetches the file with the given id and returns a local object url
     * that can be used as image src. The caller is responsible for revoking
     * the url via URL.revokeObjectURL when it is not needed anymore.
     */
    public async getFileObjectUrl(id: string): Promise<string> {
        const response = await this.getFile(id);
        return URL.createObjectURL(response.data);
    }
}
